export const HUBSPOT_DEFINED_FORECAST_TYPE_ID = 0;
export const DEFAULT_FORECAST_TYPE_AMOUNT_TYPE = 'amount';
export const DEFAULT_FORECAST_TYPE_DATE_TYPE = 'closedate';